import { useEffect } from 'react';
import Script from 'next/script';

import type { RecommendationContext } from '@/lib/useDynamicYield';

const DynamicYieldScripts = ({
  context = {},
}: {
  context: RecommendationContext;
}) => {
  const isProduction = process.env.NEXT_PUBLIC_SANITY_DATASET === 'production';
  let sectionId = isProduction ? 9880147 : 9880019;

  if (process.env.NODE_ENV === 'development') {
    sectionId = 9880229;
  }

  useEffect(() => {
    if (window?.DY?.recommendationContext) {
      window.DY.recommendationContext = context;
    }
  }, [context]);

  return (
    <>
      <Script
        id="dy-recommendation-context"
        type="text/javascript"
        key="dy-context-script"
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{
          __html: `
            window.DY = window.DY || {};
            DY.recommendationContext = ${JSON.stringify(context)};
          `,
        }}
      />
      <Script
        id="dy-api-dynamic-script"
        type="text/javascript"
        key="dy-api-dynamic-script"
        defer
        src={`//cdn-eu.dynamicyield.com/api/${sectionId}/api_dynamic.js`}
      />
      <Script
        id="dy-api-static-script"
        type="text/javascript"
        key="dy-api-static-script"
        defer
        src={`//cdn-eu.dynamicyield.com/api/${sectionId}/api_static.js`}
      />
    </>
  );
};

export { DynamicYieldScripts };
